import { useState } from "react";
import { Loader2, LogIn } from "lucide-react";
import { useAdminAuth } from "../../context/AdminAuthContext";
import { toast } from "../../components/ui/sonner";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) return;
    setSubmitting(true);
    try {
      await login(email.trim(), password);
      toast("Welcome back", { description: "Signed in as admin." });
    } catch (err) {
      toast("Sign in failed", { description: err.message });
    } finally {
      setSubmitting(false);
    }
  };

  const inputCls =
    "w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-[#00B4D8]/60";

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#0A192F] flex items-center justify-center px-6">
      <div className="w-full max-w-md rounded-3xl border border-white/12 bg-[#112240] p-8">
        <div className="flex items-center gap-3 mb-8">
          <img src="/geonetix-logo-full.webp" alt="GeoNetix" className="h-12 w-auto object-contain" />
          <div>
            <div className="font-display font-black text-xl leading-tight">GeoNetix</div>
            <div className="text-xs font-mono-gx uppercase tracking-[0.2em] text-[#00B4D8]">Admin</div>
          </div>
        </div>
        <h1 className="font-display font-black text-2xl tracking-tight mb-1">Sign in</h1>
        <p className="text-sm text-slate-400 mb-6">Enter your admin credentials to continue.</p>
        <form onSubmit={submit} data-testid="admin-login-form" className="space-y-4">
          <label className="block">
            <span className="mb-2 block text-sm text-slate-300">Email</span>
            <input
              data-testid="admin-email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@example.com"
              className={inputCls}
            />
          </label>
          <label className="block">
            <span className="mb-2 block text-sm text-slate-300">Password</span>
            <input
              data-testid="admin-password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className={inputCls}
            />
          </label>
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={submitting}
            className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#4CAF50] px-6 py-3 text-sm font-semibold text-[#04140a] hover:brightness-110 disabled:opacity-60 transition"
          >
            {submitting ? <Loader2 size={16} className="animate-spin" /> : <LogIn size={16} />}
            {submitting ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
